import React from 'react';
import { SubheaderRowReverse } from './styled';
import { Col } from '../../styled';

const GroupEventItemSubHeader = ({ options }) => {
    return (
        <SubheaderRowReverse>
            {options['2'] ? (
                <Col>2</Col>
            ) : !options['2'] && options['X'] ? (
                <Col>&nbsp;</Col>
            ) : null}
            {options['X'] ? <Col>X</Col> : null}
            {options['1'] && !options['X'] && !options['2'] ? (
                <Col>&nbsp;</Col>
            ) : null}
            {options['1'] ? <Col>1</Col> : <Col>&nbsp;</Col>}
        </SubheaderRowReverse>
    );
};

export default GroupEventItemSubHeader;
